import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    login_state: {
      is_show_logout: false,
      is_show_dialog: false,
      is_show_bind_mobile: false,
      is_retrieve_dialog: false, //找回密码弹窗
      login_way: "wechat",
      // login_way: "verificationCode", //短信验证码注册
    },
    user: {},

    undealCount: 0 // 求职者待处理数量
  },
  mutations: {
    changeLoginState(state, params) {
      var arr = [];
      if (Object.prototype.toString.call(params) === "[object Array]") {
        arr = params;
      } else if (typeof params === "object") {
        arr.push(params);
      } else {
        return;
      }

      arr.forEach(element => {
        const { key, value } = element;
        state.login_state[key] = value;
      });
    },
    changeUser(state, params) {
      const { key, value, data } = params;

      if (data) {
        state.user = data;
      } else if (key) {
        state.user[key] = value;
      }
    },

    // 获取待处理数据
    changeCount(state, params) {
      const { count, source } = params || {};
      if (count >= 0) {
        if (source == "ajax") {
          console.log("undealCount...", params);
          // 缓存数据
          localStorage.setItem(
            "undealCount",
            JSON.stringify({ undealCount: count, t: new Date().getTime() })
          );
        }
        state.undealCount = count;
      }
    }
  },
  actions: {
    setStorageMessages(context, params) {}
  }
});



// WEBPACK FOOTER //
// ./src/store/global-store.js